import { useQuery } from '@tanstack/react-query';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AuditLog } from '../../../types/auditLogs';
import { AcademiaResponse } from '../../../types/common';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useAuditLogsActions = (modelName?: string) => {
  // GET action to fetch all the audit logs declared here
  const getAuditLogsHandler = useQuery({
    queryKey: ['user-audit-logs'],
    queryFn: async (): Promise<AcademiaResponse<Array<AuditLog>>> => {
      const response = await getPrivateAxiosInstance('user').get(
        `/audit/logs/${modelName}/`
      );

      return response.data;
    },

    ...returnQueryConfig(!!modelName),
  });

  return { getAuditLogsHandler };
};

export default useAuditLogsActions;
